;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import { useQuery } from '@tanstack/react-query'
import { useRef } from 'react'
import { PAGE_SIZE } from 'src/deprecated/constants'
import { getSalesQueryOptions } from 'src/deprecated/hooks/api/useGetSales'

const EXPIRATION_HOURS = 48

const calculateExpirationFrom = () => {
  const expirationDate = new Date()
  expirationDate.setHours(expirationDate.getHours() + EXPIRATION_HOURS)
  expirationDate.setMinutes(0, 0, 0) // to avoid infinite requests
  return expirationDate.toISOString()
}

/**
 *
 * Combine two requests into a single hook for simultaneous suspension.
 *
 * The two requests are put together in one hook,
 * to make them suspendable together. The consumer components
 * can have different heights, and if we would have two independent
 * suspense boundaries, the UI would jump 2 times, instead of once.
 */
export function useExpiringAndUnreadOrders() {
  // oxlint-disable-next-line react-hooks/refs -- TODO: fix this genuine linter error if you are working on this code.
  const expiredFrom = useRef(calculateExpirationFrom()).current
  const canaryClient = useCanaryClient()
  const expiringSalesQuery = useQuery({
    ...getSalesQueryOptions({
      status: 'CURRENT',
      order: 'priority',
      page: 1,
      expiredFrom,
      canaryClient,
    }),
    retry: 0,
  })
  const unreadSalesQuery = useQuery({
    ...getSalesQueryOptions({
      status: 'CURRENT',
      order: '-expired_at',
      page: 1,
      hasRead: false,
      canaryClient,
    }),
    retry: 0,
  })

  return {
    expiring: {
      sales: expiringSalesQuery.data?.results ?? [],
      totalResults: expiringSalesQuery.data?.count ?? 0,
      totalPages: expiringSalesQuery.data
        ? Math.ceil(expiringSalesQuery.data.count / PAGE_SIZE)
        : 0,
    },
    unread: {
      sales: unreadSalesQuery.data?.results ?? [],
      totalResults: unreadSalesQuery.data?.count ?? 0,
      totalPages: unreadSalesQuery.data
        ? Math.ceil(unreadSalesQuery.data.count / PAGE_SIZE)
        : 0,
    },
  }
}
